export default __webpack_public_path__ + "static/media/tabebuya-5.f493039f.JPG";